import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IPartnerPOC, IDropdown } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";

const schema = yup.object({
    name: yup.string().required("POC Name is required"),
    email: yup.string().email().nullable(),
    contact: yup.string().nullable(),
    partnerId: yup.number().required("Partner is required").min(1, "Partner is required")
});

interface Iprops {
    singleData: IPartnerPOC,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [partners, setPartners] = useState<IDropdown[]>();
    const [submitting, setSubmitting] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IPartnerPOC>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    useEffect(() => {
        loadPartners();
    }, []);

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const loadPartners = async () => {
        const response = await Fetch("partner/dropdown", "GET", null, null, null);
        if (response) {
            setPartners(await response.json());
        }
    }

    const saveToDB = async (body: IPartnerPOC) => {
        setSubmitting(true);
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch(`partnerpoc${props.singleData.id ? '/' + props.singleData.id : ''}`, method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
        }
        setSubmitting(false);
    }

    const onHide = () => {
        props.hideDialog(); reset({});
    }

    function onSubmit(data: any) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit POC" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput required label="Name" control={control} name="name" error={errors.name?.message} />
                <JVInput label="Email" control={control} name="email" error={errors.email?.message} />
                <JVInput label="Contact" control={control} name="contact" error={errors.contact?.message} />
                <JVDropdown required label="Partner" control={control} options={partners} optionLabel="name" optionValue="id" name="partnerId" placeholder="Select Partner" error={errors.partnerId?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}
